import React from 'react';
import { IconWrapper } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { ICON_SIZE } from '../../../global/constants';

/**
 * IconButton renders an interactive icon-based button with customizable styling and SVG icon display
 * @param {number} variant - Button variant number for styling differentiation
 * @param {number} size - Size dimension value for button sizing
 * @param {string} iconName - SVG icon name/identifier for display
 * @param {string} iconViewBox - Optional SVG viewBox dimensions (default: '0 0 18 18')
 * @param {string} fill - Optional fill color for the SVG icon
 * @param {string} iconColorType - Primary/secondary color theme for icon styling
 * @param {React.MouseEventHandler<HTMLButtonElement>} onClick - Optional click event handler function
 * @param {string} className - Optional CSS class names for additional styling
 * @param {string} type - Button shape type (rounded/square)
 * @param {boolean} isDisabled - Whether the button is disabled/disabled state
 * @param {boolean} isMultiColor - Whether the button is a multi-color icon
 * @param {string} id - Optional unique identifier for the button
 */
interface Props {
  variant: number;
  size: number;
  iconName: string;
  iconViewBox?: string;
  fill?: string;
  iconColorType?: 'primary' | 'secondary';
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: 'rounded' | 'square';
  isDisabled?: boolean;
  isMultiColor?: boolean;
  id?: string;
}

const IconButton: React.FC<Props> = ({
  iconName,
  variant,
  size,
  fill,
  iconViewBox = `0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`,
  iconColorType,
  onClick,
  className,
  type,
  isDisabled,
  isMultiColor,
  id
}) => {
  return (
    <>
      <IconWrapper
        variant={variant}
        size={size}
        iconColorType={iconColorType}
        onClick={onClick}
        className={className}
        btnType={type}
        type='button'
        isDisabled={isDisabled}
        isMultiColor={isMultiColor}
        id={id}
        aria-label={iconName}>
        <SVGIcon fill={fill} name={iconName} viewBox={iconViewBox} width={ICON_SIZE.MD} height={ICON_SIZE.MD} />
      </IconWrapper>
    </>
  );
};

export default IconButton;
